import gql from 'graphql-tag';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';
// import { AssetImageSubtype } from 'src/modules/assets';
// import { FRAGMENT_DESIGNER_CARD } from 'src/modules/designers/listing/queries';
import { FRAGMENT_ARTICLE_CARD } from 'src/modules/articles/listing/queries/index';

const FRAGMENT_DESIGNER_CARD = gql`
  fragment designerCardFields on Designer {
    name
    slug
    assets(where: { subtype: "picture.personPortrait." }, limit: 1) {
      subtype
      format_3x2 {
        url
        alternativeText
      }
    }
  }
`;

export const QUERY_DESIGNERS_DETAILS = gql`
  query DesignersDetails($slug: String!) {
    designers(where: { slug: $slug }, limit: 1) {
      ...designerCardFields
      id
      description_en
      description_de
      dynamic_content {
        ...dynamicZone
      }
    }
    articles(where: { designer: { slug: $slug } }, limit: 3, sort: "published_at:desc") {
      ...articleCardFields
    }
  }
  ${FRAGMENT_DYNAMIC_ZONES}
  ${FRAGMENT_DESIGNER_CARD}
  ${FRAGMENT_ARTICLE_CARD}
`;

export const QUERY_ALL_DESIGNERS = gql`
  query Designers($designerId: ID!) {
    designers(where: { id_ne: $designerId }, limit: 3) {
      ...designerCardFields
    }
  }
  ${FRAGMENT_DESIGNER_CARD}
`;
